// const BASE_URL = "https://uat.zinger.co.in";
// const BASE_URL = "https://billing.avmjewellers.com";
// const BASE_URL = "https://zinger.prod-rasiinfotech.in";
const WEB_URL  = "https://avm.prod-rasiinfotech.in";

const BASE_URL = "https://development.zinger.co.in";


export { BASE_URL , WEB_URL};